import { CSSProperties } from "react";
import { getButtonColor, getButtonTextColor } from "./cssVariables";

const isNycSite = process.env.REACT_APP_NYC_MODE === "true";

/** NYC keeps Arco primary (blue) OAuth buttons; WERULE uses black theme buttons. */
export function getOAuthButtonProps(extraStyle?: CSSProperties) {
  const baseStyle: CSSProperties = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    gap: 8,
    width: "100%",
    ...extraStyle,
  };

  if (isNycSite) {
    return { type: "primary" as const, style: baseStyle };
  }

  return {
    style: {
      ...baseStyle,
      color: getButtonTextColor(),
      backgroundColor: getButtonColor(),
    },
  };
}
